import styled from 'styled-components';

/**
 * Marco de la pantalla de error SUELTA — la del `errorElement` de la raíz del
 * router. Se ve cuando no hay sesión, o cuando revienta un loader y ya no se
 * puede confiar en el resto de la aplicación, así que aquí no hay cabecera ni
 * menú: solo el logo, para que se sepa dónde está uno, y la tarjeta.
 *
 * 🔴 Sin la foto del login a propósito: es la imagen de "estás fuera", y este
 * error le puede salir a alguien con la sesión perfectamente abierta.
 */
export const Container = styled.div`
  min-height: 100vh;
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: ${({ theme }) => theme.spaces.xl}rem;
  padding: ${({ theme }) => theme.spaces.xl}rem
    ${({ theme }) => theme.spaces.l}rem;
  background-color: ${({ theme }) => theme.colors.white};
`;

export const Logo = styled.img`
  width: 11rem;
  height: 3.236rem;

  @media (max-width: 768px) {
    width: 9rem;
    height: 2.65rem;
  }
`;
